import Repository from '@/libs/axios'

const staffSettingsResource = '/admin/settings/staff-category'
const staffCategoryResource = '/admin/staff-category'

const defaultPagination = 20

export default {
  getStaffSettings() {
    return Repository.get(`${staffSettingsResource}`)
  },
  updateStaffSettings(payload) {
    return Repository.put(`${staffSettingsResource}`, payload)
  },
  getStaffCategoryTypesList(pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${staffCategoryResource}/staff-category-list?page=${pageNumber}&paginate=${pagination}`)
  },
  getStaffCategoryTypesListNoPagination() {
    return Repository.get(`${staffCategoryResource}/staff-category-list?noPagination`)
  },
  createStaffCategoryType(payload) {
    return Repository.post(`${staffCategoryResource}/add-staff-category`, payload)
  },
  updateStaffCategoryTypeStatus(id, payload) {
    return Repository.put(`${staffCategoryResource}/${id}/update-staff-category-status`, payload)
  },
  getActiveStaffCategoryList() {
    return Repository.get(`${staffCategoryResource}/active-staff-category-list`)
  },
}
